import { useAtom } from '@reatom/npm-react'

import { AuthDialog } from '@root/shared/ui/auth-modal/auth-dialog'

import { storageSessionAtom } from '../atoms'
import { StorageSession } from '../model'

import { InitializeSecureStorageForm } from './initialize-secure-storage-form'

import type { CreatePasswordController } from '../atoms'
import type { DialogControlProps } from '@root/shared/ui-kit'

type CreateLocalPasswordDialogProps = {
  controller: CreatePasswordController
} & DialogControlProps

export const CreateLocalPasswordDialog: React.FC<
  CreateLocalPasswordDialogProps
> = ({ controller, open, onOpenChange }) => {
  const [storageSession] = useAtom(storageSessionAtom)

  return (
    <AuthDialog
      open={open}
      onOpenChange={(open) => {
        const isUnlocked =
          storageSession && storageSession instanceof StorageSession.Unlocked

        if (!open && !isUnlocked) {
          controller.onCancel()
        }
        onOpenChange?.(open)
      }}
    >
      <InitializeSecureStorageForm
        onInitialized={({ password }) => {
          controller.onInitialized({ password })
        }}
      />
    </AuthDialog>
  )
}
